<template>
  <div>
    <header class="lmy-header lmy-header-w">
      <i class="iconfont icon-yuyin" @click="routetokPage('/user')"></i>
    我的订单
    </header>
    <ul class="order-menu">
      <li @click="handleTab('my',0)" :class="OrderType == 'my'?'item active':'item'"><span>酒店订单</span></li>
      <li @click="handleTab('pre',1)" :class="OrderType == 'pre'?'item active':'item'"><span>度假订单</span></li>
      <!-- <li @click="handleTab('ticket',3)" :class="OrderType == 'ticket'?'item active':'item'"><span>门票订单</span></li> -->
    </ul>
    <!-- 我的订单 -->
    <div class="order-list" style="padding-top: 1.9rem;">
      <div class="my-order" v-if="OrderType == 'my'">
        <div class="order-list-item" v-for="item in list" @click="routeTodetails(item)" v-if="item.OrderType==0">
          <div class="item-header">
            <p class="left">{{item.HotelName}}</p>
            <div class="right">
              <span v-if="item.Status === 8">取消单 </span>
              <span v-else-if="item.Status === 9">处理中</span>
              <span v-else-if="item.Status === 10">已确认</span>
              <span v-else-if="item.Status === 27">可入住</span>
              <span v-else-if="item.Status === 2">处理中</span>
              <span v-else-if="item.Status === 0"> 无效单</span>
              |
              <span v-if="item.PaymentType === 0">未付款</span>
              <span v-else-if="item.PaymentType === 1">处理中</span>
              <span v-else-if="item.PaymentType === 2">未付清</span>
              <span v-else-if="item.PaymentType === 3">已付款</span>
              <span v-else-if="item.PaymentType === 4">已退款</span>
            </div>
          </div>
          <div class="item-body">
            <p>入离：{{item.CheckIn | dateShort}}-{{item.CheckOut | dateShort}} <span v-if="item.NightCount">| 共{{item.NightCount}}晚</span><span v-if="item.RoomCount"> ({{item.RoomCount}}间)</span></p>
            <p>{{item.RoomName}} <span v-if="item.RPName">| {{item.RPName}}</span></p>
            <p>总计：<span class="sym">¥</span><span class="num">{{(item.TotalAmount).toFixed(2)}}</span></p>
          </div>
          <div class="item-footer">
            <div class="left">订单：{{item.OrderNO}}</div>
            <div class="right">
              <span class="r-btn"
                    v-if="(item.PaymentType == 0||item.PaymentType == 1)&&(item.Status == 9||item.Status == 10||item.Status == 2)&&item.SettlementType==1||item.OnlineOrderStatus == 0"
                    @click="routeToPay(item,$event)">去支付</span>
              <span class="r-btn" v-if="item.CanCancel" @click="cancel(item,$event)">取消订单</span>
            </div>
          </div>
          <div class="item-footer" style="margin: 0;">
            <div class="left">时间：{{item.BookingOn | dateLong}}</div>
          </div>
        </div>
      </div>
      <div class="my-order package" v-else>
        <div class="order-list-item" v-for="item in list" @click="routeTodetails(item)">
          <div class="item-header">
            <p class="left element" :class="item.PackageType==2?'green':''">{{item.PackageType==1?'度假':'预售'}}</p>
            <div class="right">
                  <span v-if="item.PackageType==1">
										<span v-if="item.Status == 10&&item.NeedPay">待付款</span>
										<span v-if="item.Status == 10&&!item.NeedPay">待确认</span>
										<span v-if="item.Status == 11&&item.NeedPay">待付款</span>
										<span v-if="item.Status == 11&&!item.NeedPay">待确认</span>
										<span v-if="item.Status == 20">已确认</span>
										<span v-if="item.Status == 40">已使用</span>
										<span v-if="item.Status == 50">已取消</span>
                  </span>
                  <span v-else>
                    <span v-if="item.Status == 10&&item.NeedPay">待付款</span>
                    <span v-if="item.Status == 10&&!item.NeedPay">待预约</span>
                    <span v-if="item.Status == 11">预约中</span>
                    <span v-if="item.Status == 12">部分预约</span>
                    <span v-if="item.Status == 20">已预约</span>
                    <span v-if="item.Status == 40">已使用</span>
                    <span v-if="item.Status == 50">已取消</span>
                  </span>
            </div>
          </div>
          <div class="item-body">
            <p>{{item.ProductName}}</p>
            <div class="flex-box">
              <span v-if="item.PackageType==1">出发日期 {{item.CheckIn | dateToYMDline}}</span>
              <span v-else>有效期至 {{item.EndActiveDate | dateToYMDline}}</span>
              <span>
                <span class="sym">¥</span><span class="num">{{(item.TotalAmount).toFixed(2)}}</span>
              </span>
            </div>
          </div>
          
          <div class="item-footer">
            <div class="left">订单编号：{{item.QGOrderNo}}</div>
            <div class="right">
              <span class="r-btn" v-if="item.NeedPay" @click="routeToPay(item,$event)">去支付</span>
              <span class="r-btn" v-if="item.NeedReserve" @click="routeTodetails(item)">去预约</span>
              <span class="r-btn" v-if="item.CanCancel" @click="cancel(item,$event)">取消</span>
            </div>
          </div>
          <div class="item-footer" style="margin: 0;">
            <div class="left">下单时间：{{item.CreateDate | dateLong}}</div>
          </div>
        </div>
      </div>
 
      <infinite-loading @infinite="initData" ref="infiniteLoading">
				<span slot="no-more">
					没有更多了...
				</span>
        <span slot="no-results">
					您暂时没有任何订单！
				</span>
    
      </infinite-loading>
      <div class="book-comfirming" v-if="isBookCancel">
        <div class='f-modal'>
          <div class='f-modal-head'>提示</div>
          <div class='f-modal-body'>
            <p>正在取消订单，请稍候</p>
          </div>
        </div>
      </div>
      <!-- <meetingList v-if="OrderType == 'meet'"></meetingList> -->
      <!-- <myPresaleOrder v-if="OrderType == 'pre'"></myPresaleOrder> -->
    </div>


    <Cancel :option="cancelData" @select="cancelData.select"></Cancel>
    <transition name="slide">
      <invoice v-if="isInvoiceBox==true" @changeFilter="changeFilter" @offInvoice="offInvoice" :orderMsg="orderMsg"
               :Currency="orderMsg.Currency"></invoice>
    </transition>
  </div>
</template>
<script>
import InfiniteLoading from 'vue-infinite-loading';
import Cancel from './../../common/cmpnt/cancel.vue';
import Invoice from './../../invoice/invoice.vue';
import meetingList from './../../usr/meeting/list';
import myPresaleOrder from './../../usr/myPresaleOrder/myPresaleOrder.vue';

export default {
  name: 'myOrder',
  components: {
    InfiniteLoading,
    Cancel,
    Invoice,
    meetingList,
    myPresaleOrder
  },
  data() {
    return {
      list: [],
      Page: 1,
      PageSize: 10,
      total: 0,
      OrderTypeId:0,
      OrderType: "my",
      Hcancel:this.Api.cancelOrder,
      Ocancel:this.Api.cancelOnlinePackageOrder,
      HAPI:this.Api.getOrderList,
      OAPI:this.Api.getOnlinePackageOrderList,
      isBookCancel: false,
      cancelData: {
        show: false,
        title: '取消订单',
        content: '确定取消该订单吗？',
        token: '',
        select: (token) => {
          this.cancelOrder(token);
        }
      },
      isInvoiceBox: false,//显示发票页面
      orderMsg: {},//订单信息
    }
  },
  methods: {
    handleTab(type,typeId){
      this.OrderType = type
      this.OrderTypeId = typeId
      this.changeFilter()
    },
    // 开发票 按钮
    openInvoice(item) {
      this.isInvoiceBox = true
      this.orderMsg = item
    },
    offInvoice() {
      this.isInvoiceBox = false
    },
    cancel(item, $event) {
      $event.stopPropagation();
      this.cancelData.token = item.Token;
      this.cancelData.show = true;
    },
    cancelOrder(token) {
      var that = this;
      var param = {
        'Token': token
      }
      var myAPI=''
      if(this.OrderTypeId == 0){
        myAPI = that.Hcancel
      }else{
        myAPI = that.Ocancel
      }
      that.isBookCancel = true;
      that.postRequest({
        url: myAPI,
        params: param
      }).then(res => {
        that.isBookCancel = false;
        that.cancelData.show = false;
        if (res && res.IsSuccess) {
          that.error({title: '提示', content: '订单取消成功'});
          that.changeFilter();
        } else {
          that.error({title: '提示', content: res.Msg || '取消失败'});
        }
      });
    },
    //去支付
    routeToPay(order, $event) {
      $event.stopPropagation();
      // 如果是酒店订单
      if (order.OrderType == 0) {
        this.dao.set('thisBookingOrderNO', order.OrderNO);
        this.$router.push({path: '/wxPay', query: {OrderNO: order.OrderNO,flag:true}});
        return;
      } else {
        this.dao.set('thisBookingOrderNO', order.QGOrderNo);
        this.$router.push({path: '/wxPay', query: {OrderNO: order.QGOrderNo}});
      }
    },
    //查看订单详情
    routeTodetails(item) {
      var order = ''
      if(item.OrderType == 0){
          order = item.OrderNO
      }else{
          order = item.QGOrderNo
      }
      this.$router.push({path: '/BookDetails', query: {OrderNO:order,OrderTypeId:item.OrderType,source:true}});
    },
    //条件更新后重置参数和结果
    changeFilter($state) {
      this.Page = 1;
      this.total = 0;
      this.list = [];
      this.$nextTick(() => {
        this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
      });
    },
    initData($state) {
      var that = this;
      if (that.total > 0 && (((that.Page - 1) * that.PageSize) > that.total)) {
        $state.complete();
        return;
      }
      
      var myAPI=''
      if(that.OrderTypeId == 0){
        myAPI = that.HAPI
      }else{
        myAPI = that.OAPI
      }
      var param = {
        OrderTypeId: that.OrderTypeId,
        Page: that.Page,
        PageSize: that.PageSize,
      }
      that.postRequest({
        url: myAPI,
        params: param
      }).then(res => {
        if (res && res.IsSuccess && res.Result) {
          if(res.Total==0){
            $state.complete();
          }else{
            that.total = res.Total;
            that.Page += 1;
            that.list = this.list.concat(res.Result);
            $state.loaded();
          }
        } else {
          $state.complete();
        }
      });
    }
  },
  created(){
    var that = this
      that.OrderType = that.$route.query.type||'my';
      that.OrderTypeId = that.$route.query.typeId||0;
  }
}
</script>



// WEBPACK FOOTER //
// src/components/usr/myOrder/myOrder.vue